import { styled } from "@mui/material";

export const Overlay = styled("div")`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
`;

export const Content = styled("div")<{ device: "tablet" | "mobile" }>`
  position: relative;
  max-width: 90vw;
  max-height: 85vh;
  /* iOS Safari 툴바로 인한 vh 오차 보정 (동적 뷰포트) */
  max-height: 85dvh;

  img {
    display: block;
    max-width: 90vw;
    /* 태블릿 원본 이미지가 600x600 기준으로 제작되어 그 이상 커지지 않도록 제한 */
    ${({ device }) => (device === "tablet" ? "width: min(90vw, 600px);" : "")}
    max-height: 85vh;
    max-height: 85dvh;
    object-fit: contain;
  }
`;

export const CloseButton = styled("button")`
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: 80px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;

// 이미지에 그려진 스토어 버튼 위에 겹쳐지는 투명 링크 영역
export const StoreLink = styled("a")<{ device: "tablet" | "mobile" }>`
  position: absolute;
  display: block;
  cursor: pointer;

  ${({ device }) =>
    device === "tablet"
      ? `
    left: 20%;
    width: 59%;
    top: 60%;
    height: 24%;
  `
      : `
    left: 0;
    width: 60%;
    top: 50%;
    height: 50%;
  `}
`;
